import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AppProvider from './components/AppProvider';
import emailjs from '@emailjs/browser';

emailjs.init('Q4_DdykXQUb75sS3B');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(
    <AppProvider>
        <App />
    </AppProvider>
);
